"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Trybe
 * This site provides documentation on how to use the Trybe Shop API
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
var runtime_1 = require("../runtime");
var _1 = require("./");
/**
* @export
* @enum {string}
*/
var PreviewSmsMessageMessageTypeEnum;
(function (PreviewSmsMessageMessageTypeEnum) {
    PreviewSmsMessageMessageTypeEnum["BasketConfirmed"] = "basket_confirmed";
    PreviewSmsMessageMessageTypeEnum["BasketCancelledWithCharge"] = "basket_cancelled_with_charge";
    PreviewSmsMessageMessageTypeEnum["BasketCancelledWithoutCharge"] = "basket_cancelled_without_charge";
    PreviewSmsMessageMessageTypeEnum["BasketReminder"] = "basket_reminder";
    PreviewSmsMessageMessageTypeEnum["BasketFollowUp"] = "basket_follow_up";
    PreviewSmsMessageMessageTypeEnum["PayByLinkRequest"] = "pay_by_link_request";
})(PreviewSmsMessageMessageTypeEnum = exports.PreviewSmsMessageMessageTypeEnum || (exports.PreviewSmsMessageMessageTypeEnum = {}));
function PreviewSmsMessageFromJSON(json) {
    return PreviewSmsMessageFromJSONTyped(json, false);
}
exports.PreviewSmsMessageFromJSON = PreviewSmsMessageFromJSON;
function PreviewSmsMessageFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'message_type': json['message_type'],
        'params': !runtime_1.exists(json, 'params') ? undefined : _1.SmsMessageParamsFromJSON(json['params']),
    };
}
exports.PreviewSmsMessageFromJSONTyped = PreviewSmsMessageFromJSONTyped;
function PreviewSmsMessageToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'message_type': value.message_type,
        'params': _1.SmsMessageParamsToJSON(value.params),
    };
}
exports.PreviewSmsMessageToJSON = PreviewSmsMessageToJSON;
